// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import "babel-polyfill"
require("babel-polyfill");
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import VueI18n from 'vue-i18n'
import Api from './common/ApiFactory.js'
import Functions from './common/functions.js'
import Filters from './common/filters.js'
import Dao from './common/dao/dao.js'
import VueAMap from 'vue-amap';
import { AMapManager, AMapMarker } from 'vue-amap';
import VCharts from 'v-charts'
import VueProgressBar from 'vue-progressbar'
// 字体文件
import zh_tran from "./common/langs.js"

import Blob from './common/excel/Blob.js'
import Export2Excel from './common/excel/Export2Excel.js'



require('./assets/style.css')
require('./assets/css.css')
require('./assets/addition.css')
require('./assets/animation.css')
require('./assets/font/iconfont.css')
require('./assets/font-two/iconfont.css')
require('./assets/home-login.css')
require('animate.css')



Vue.config.productionTip = false

Vue.prototype.Api = Api;
Vue.prototype.$zh_tran = zh_tran
var dao = new Dao.Dao('dingfangyi');
Vue.prototype.dao = dao;

Vue.use(VueI18n); //中英文双语
Vue.use(VueResource); //路由
Vue.use(Functions); //公用方法
Vue.use(Filters); //过滤器
Vue.use(VCharts); //表格
Vue.use(VueAMap);; //高德
Vue.component('el-amap-marker', AMapMarker);

VCharts.theme = { smooth: true }

VueAMap.initAMapApiLoader({
    key: '3819f24ec8cb6f5e4cf922a0b7f70f64',
    plugin: ['AMap.Scale', 'AMap.Bounds'],
    v: '2.0',
    uiVersion: '1.1'
})

//进度条
Vue.use(VueProgressBar, {
        position: 'relative',
        color: '#ff8412',
        failedColor: 'red',
        thickness: '10px'
    })
    // 全局请求头
Vue.http.headers.common['Accept-Language'] = 'zh-CN'

// Vue.http.headers.common['Accept-Language'] = 'en-US'

// import zh from './common/lang/zh';
// import en from './common/lang/en';

// // 使用多文件管理不同的语言
// const i18n = new VueI18n({
//     locale: localStorage.getItem('language') || 'zh',
//     messages: {
//         'zh': zh,
//         'en': en
//     }
// })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js